import { ENVIRONMENT } from '../../../app.constants';

declare global {
  interface Window {
    ENVIRONMENT: {
      MENU_MANAGEMENT_COMPONENT: string;
      API_URI: string,
      BC_URI: string,
    };
  }
}

export class EnvironmentService {
  private environment: {
    OC_API: string;
    BC_API: string;
  };

  constructor() {
    this.environment = this.getAPIUrl();
  }

  getEnvironment() {
    return this.environment;
  }

  getAPIUrl() {
    if (window.ENVIRONMENT.API_URI) {
      return {
        OC_API: window.ENVIRONMENT.API_URI,
        BC_API: window.ENVIRONMENT.BC_URI
      }
    }
    const host = window.location.hostname;

    switch (host) {
      case ENVIRONMENT.LOCAL[0]:
        return {
          OC_API: ENVIRONMENT.LOCAL[1],
          BC_API: ENVIRONMENT.LOCAL[2]
        };
      case ENVIRONMENT.IQA[0]:
        return {
          OC_API: ENVIRONMENT.IQA[1],
          BC_API: ENVIRONMENT.IQA[2]
        };
      case ENVIRONMENT.IWEB[0]:
        return {
          OC_API: ENVIRONMENT.IWEB[1],
          BC_API: ENVIRONMENT.IWEB[2]
        };
      case ENVIRONMENT.TEST[0]:
        return {
          OC_API: ENVIRONMENT.TEST[1],
          BC_API: ENVIRONMENT.TEST[2]
        };
      case ENVIRONMENT.BETA[0]:
        return {
          OC_API: ENVIRONMENT.BETA[1],
          BC_API: ENVIRONMENT.BETA[2]
        };
      case ENVIRONMENT.LIVE[0]:
        return {
          OC_API: ENVIRONMENT.LIVE[1],
          BC_API: ENVIRONMENT.LIVE[2]
        };
      default:
        return {
          OC_API: ENVIRONMENT.IWEB[1],
          BC_API: ENVIRONMENT.IWEB[2]
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/util/environment.service.ts